import { Injectable } from '@angular/core';

import { Timestamp, collection, doc, setDoc, count, sum, average, getAggregateFromServer, getFirestore, deleteDoc, getDocs, where, query, documentId, getDoc, updateDoc, getDocFromCache, addDoc, orderBy, increment } from "firebase/firestore";
import moment from 'moment';
import { BehaviorSubject, Observable, defer, from, switchMap } from 'rxjs';
import { currentUserUid, ownedCollection, withCurrentOwner } from '../../../utils/firestore-ownership';


@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  private companies!: BehaviorSubject<any[]>

  constructor() {
    this.companies = new BehaviorSubject<any[]>([])
  }

  public async selectAll():Promise<void> {
    // console.log('CompaniesService', 'selectAll')

    const companies:any[] = []

    // const q = query(collection(getFirestore(), "Companies"), where("active", "==", true))
    const q = ownedCollection('Companies');
    const allDocs = await getDocs(q)
    allDocs.docs.forEach((d:any, j:any, h:any) => {
      // console.log('Doc:', d.id, 'ref:', d.ref, d.ref.path)

      // getDoc(d.data().ref).then((t: any)=>{
      //   console.log('CompaniesService', 'selectAll', t.id, t.data().code)
      // })
      
      const doc = { ...d.data(), id: d.id }
      companies.push(doc)
    })
    
    this.companies.next(companies)
  }

  getAll(): Observable<any[]> {
    console.log('CompaniesService', 'getAll')

    return defer(() => from(this.selectAll()).pipe(switchMap(() => this.companies.asObservable())));
  }

  async addItem(e:any):Promise<void> {
    console.log('CompaniesService', 'addItem', e)

    await addDoc(collection(getFirestore(), 'Companies'), { ...withCurrentOwner(e), created_on: Timestamp.now(), modified_on: Timestamp.now() });
    // this.companies.next([e, ...this.companies.value])
    await this.selectAll()
  }

  async delete(e:any):Promise<void>{
    console.log('CompaniesService', 'delete', e.id)

    await deleteDoc(doc(getFirestore(), 'Companies', e.id));
    await this.selectAll();
  }

  async modify(e:any):Promise<void>{
    console.log('CompaniesService', 'modify', e.id)

    if(e.amount != undefined)
      e.amount = e.amount.toString()

    await updateDoc(doc(getFirestore(), 'Companies', e.id), { ...withCurrentOwner(e), modified_on: Timestamp.now() });
    await this.selectAll();
  }

  //#region forms

  private _options:any[] = []
  async loadOptions(): Promise<any[]> {
    console.log('CompaniesService', 'loadOptions', this._options)

    this._options = [];
    const allDocs = await getDocs(query(collection(getFirestore(), 'Companies'), where('ownerUid', '==', currentUserUid()), where('active', '==', true), orderBy('name', 'asc')));
    allDocs.docs.forEach((d:any, j:any, h:any) => {      
      console.log('CompaniesService', 'loadOptions', 'Doc:', d.id, d.data().code, d.data().name)
      this._options.push({ code: d.data().code, name: d.data().name })        
    })
    
    return this._options
  }

  public translateName(c:string): string {

    if(this.companies.value.length == 0)
      this.selectAll()

    const exists = this.companies.value.filter((e:any) => {
      return e.code == c
    })[0]
    console.log('CompaniesService', 'translateName', this.companies.value, c, exists)

    if(exists != undefined)
      return exists.name
    else
      return c
  }

  //#endregion
}
